import PayrollTabs from './PayrollTabs';

export default PayrollTabs;
